{
  "general": {
    "cancel": "Tühista",
    "delete": "Kustuta",
    "no": "Ei",
    "ok": "Ok",
    "yes": "Jah"
  },
  "menu": {
    "departments": "Osakonnad",
    "home": "Avaleht",
    "procedures": "Protseduurid",
    "scheduling": "Kalender",
    "users": "Kasutajad"
  },
  "procedures": {
    "addProcedure": "Lisa protseduur",
    "deleteProcedure": "Kustuta protseduur",
    "searchProcedures": "Otsi protseduure"
  }
}